import { flexRender } from "@tanstack/react-table";
import { cn, TableHead, TableHeader, TableRow } from "twyne-new.ui";

import { getColumnWidthStyle } from "../tableResize/helper";

import ColumnResizer from "./ColumnResizer";
import { useTableContext } from "./context"

export default function TableResizeHeader({ sticky = true }) {
  const table = useTableContext()
  return <TableHeader className='border-b twy-border-base' sticky={sticky}>
    {table.getHeaderGroups().map(headerGroup => <TableRow key={headerGroup.id}>
      {headerGroup.headers.map(header => <TableResizeHeaderItem key={header.id} header={header} />)}
    </TableRow>)}
  </TableHeader>
}

const TableResizeHeaderItem = ({ header }) => {
  const { isFixedLayout } = useTableContext()

  if (header.isPlaceholder) {
    return null
  }

  return <TableHead
    data-col-id={header.column.id}
    className={cn('relative group capitalize', header.column.columnDef.meta?.headerClassName)}
    colSpan={header.colSpan}
    style={getColumnWidthStyle({ resizable: isFixedLayout, id: header.column.id, size: header.column.columnDef.size, maxSize: header.column.columnDef.maxSize })}
  >
    <ColumnResizer
      header={header}
      canResize={isFixedLayout && header.column.getCanResize()}
      tableContext={useTableContext}
    />
    {flexRender(header.column.columnDef.header, header.getContext())}
  </TableHead>
}
